<template>
  <el-table-column
    prop="creator_user.id"
    sortable="custom"
    label="Rögzítette"
    show-overflow-tooltip
    min-width="120"
  >
    <template slot-scope="scope">
      {{ scope.row.creator_user_name }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'creator_user.id',
};
</script>
